<template>
  <div
    class="container-navigation"
    :class="{ 'container-navigation__banner': isYandexBanner && showMarginTop }"
  >
    <HorizontalScroll :class="'navigation-wrap'" :scroll-position="scrollPos">
      <div ref="navigation" class="l-container navigation">
        <div
          v-for="(section, index) in filteredRoutes"
          :key="index"
          class="route"
          @click="toRoute(section.slug)"
        >
          <div
            :class="[
              'r-text heading-s',
              {
                active: section.slug === active,
              },
            ]"
          >
            <component
              :is="linkTabs.includes(section.slug) ? 'a' : 'span'"
              :href="
                linkTabs.includes(section.slug)
                  ? linkHref(section.slug)
                  : undefined
              "
              :class="{ 'tab-span': !linkTabs.includes(section.slug) }"
              @click.prevent
            >
              <span :class="{ 'tab-active': section.slug === active }">{{
                section.name
              }}</span>
              <span
                v-if="
                  count[section.slug] !== undefined && count[section.slug] !== 0
                "
                class="count"
              >
                {{ count[section.slug] }}
              </span>
            </component>
          </div>
        </div>
      </div>
    </HorizontalScroll>
  </div>
</template>

<script setup lang="ts">
import HorizontalScroll from '~/components/ui/horizontal-scroll/HorizontalScroll.vue';
import type { ScrollPos } from '~/interfaces/app';
import { useGlobalStore } from '~/stores/global';

const props = defineProps({
  count: {
    type: Object,
    default: () => {},
  },
  activeSections: {
    type: Array as () => string[],
    required: true,
  },
  active: {
    type: String,
    required: true,
  },
  pageRoute: {
    type: String,
    default: '',
  },
  baseTitle: {
    type: String,
    default: 'О товаре',
  },
  priceReviewCount: {
    type: Number,
    default: 0,
  },
  showMarginTop: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['to-route', 'change-data']);
const routes = [
  {
    slug: 'base',
    name: props.baseTitle,
  },
  {
    slug: 'offers',
    name: 'Цены',
  },
  {
    slug: 'specifications',
    name: 'Характеристики',
  },
  {
    slug: 'otzyvy',
    name: 'Отзывы',
  },
  {
    slug: 'voprosy',
    name: ' Вопросы',
  },
  {
    slug: 'videos',
    name: 'Видеообзоры',
  },
  {
    slug: 'price-chart',
    name: 'История цены',
  },
  {
    slug: 'accessories',
    name: 'Аксессуары',
  },
  {
    slug: 'shopoffers',
    name: 'Все товары',
  },
  {
    slug: 'promocodes',
    name: 'Промокоды',
  },
  {
    slug: 'shopinfo',
    name: 'О магазине',
  },
];
const { count } = toRefs(props);
const globalStore = useGlobalStore();
const isYandexBanner = computed(() => globalStore.isYandexBanner);

const filteredRoutes = ref<any>(routes);
const navigation = ref<HTMLElement>();
const scrollPos = ref<ScrollPos>({ value: 0 });

const linkHref = (slug: string) => {
  if (slug === 'otzyvy') {
    if (props.active !== 'otzyvy' && props.priceReviewCount) {
      return `${props.pageRoute}/otzyvy/`;
    }
  } else if (slug === 'voprosy') {
    if (props.active !== 'voprosy') {
      return `${props.pageRoute}/voprosy/`;
    }
  }
  return props.pageRoute + '/';
};

const linkTabs = computed(() => {
  const tabs = [];
  if (props.active === 'otzyvy' || props.active === 'voprosy') {
    tabs.push('base');
  } else if (
    props.active === 'base' &&
    (props.count.otzyvy || props.count.voprosy)
  ) {
    tabs.push('otzyvy');
  }
  return tabs;
});

const toRoute = (active: string) => {
  emit('to-route', active);
  setTimeout(() => {
    calcPosActiveBorder();
  }, 300);
};

const calcPosActiveBorder = () => {
  if (navigation.value) {
    const targetBlock = navigation.value.querySelector(`.tab-active`);
    if (targetBlock) {
      const sizes = targetBlock.getBoundingClientRect();
      const left = sizes.left - navigation.value.getBoundingClientRect().left;
      const width = sizes.width;
      scrollPos.value = {
        value: left - 10,
        width,
      };
    }
  }
};

watch(
  count,
  () => {
    filteredRoutes.value = routes.filter((section) => {
      if (!props?.active) return null;
      return (
        section.slug === 'base' || props.activeSections.includes(section.slug)
      );
    });
  },
  {
    immediate: true,
  }
);
onMounted(() => {
  calcPosActiveBorder();
});
</script>
<style lang="scss" src="./ModelNavigationScss.scss" scoped></style>
